module.exports = __webpack_public_path__ + "img/Speaker=Clarisse Schneider.13260d21.png";